<template>
  <div
    class="compreSportsMeet_selectTab"
    :style="{
      '--mixtmt_greyColor11': colorsArr
        ? colorsArr[0]
        : currThemeObj.cssStyle.greyColor11,
      '--mixtmt_whiteColor': colorsArr
        ? colorsArr[1]
        : currThemeObj.cssStyle.whiteColor,
      '--mixtmt_greyColor2': colorsArr
        ? colorsArr[2]
        : currThemeObj.cssStyle.greyColor2,
      '--mixtmt_mainColor': colorsArr
        ? colorsArr[3]
        : currThemeObj.cssStyle.mainColor,
    }"
  >
    <span
      class="tabItem"
      v-for="tab in tabArr"
      :key="typeof tab.id === 'string' ? tab.id : tab.id[0]"
      v-text="tab.name"
      :class="[tab.act ? 'act' : '', borderColor ? 'border' : '']"
      @click="clickTab(tab)"
    ></span>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'compreSportsMeet_selectTab',
  mixins: [cup_base_data_mixin],
  props: {
    borderColor: {
      //是否给tab外面加描边
      type: Boolean,
      default: false,
    },
    isPageJumpFlag: {
      //点击tab是否跳转路由
      type: Boolean,
      default: true,
    },
    tabArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    pageJumpParams: {
      type: Array,
      default: () => {
        return []
      },
    },
    colorsArr: {
      type: [Array, null],
      default: null, // ['greyColor11:bgColor', 'whiteColor:actBgColor', 'greyColor2:color', 'mainColor(不可与父级背景色相同,因为它也控制着鼠标经过的背景色):actColor'],
    },
  },
  data() {
    return {}
  },
  watch: {
    tabArr(newVal, oldVal) {
      console.debug('change tabArr')
      if (this.isPageJumpFlag) {
        setTimeout(() => {
          this.init()
        }, 10)
      }
    },
    $route(to, from) {
      // 如果是从b到a页面，则不缓存b
      // 注意 路由那么要与组件name一致
      console.debug(from.name, to.name)
      if (from.name !== to.name) {
        this.init()
      }
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (this.isPageJumpFlag) {
        const initPathName = this.$route.name
        console.debug('initPathName:', initPathName)
        this.tabArr.forEach((val) => {
          if (val.pathName.indexOf(initPathName) > -1) {
            val.act = true
          } else {
            val.act = false
          }
        })
      }
    },
    clickTab(tab) {
      this.$emit('clickTabEvent', tab)
      console.debug('clickTabEvent:', this.pageJumpParams, tab)
      if (this.isPageJumpFlag) {
        const [query, params] = this.pageJumpParams
        const pathName =
          typeof tab.pathName === 'string' ? tab.pathName : tab.pathName[0] //数组的话默认返回第一个，第一个是父级
        this.pageReplaceJump(this.$router, pathName, query, params)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.compreSportsMeet_selectTab {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  .tabItem {
    margin-right: 0.35vw;
    padding: 0 2.0833vw;
    height: 2.778vw;
    line-height: 2.778vw;
    background-color: var(--mixtmt_greyColor11);
    color: var(--mixtmt_greyColor2);
    font-size: 0.972vw;
    border-radius: 0.4vw 0.4vw 0 0;
    &:last-child {
      margin-right: 0;
    }
    &.act {
      position: relative;
      background-color: var(--mixtmt_whiteColor);
      color: var(--mixtmt_mainColor);
      font-weight: bold;
      &.border::before {
        content: '\20';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        border: 1px solid var(--mixtmt_mainColor);
        border-bottom: none;
        border-radius: 0.4vw 0.4vw 0 0;
      }
    }
  }
}

.mixtmt_pc .compreSportsMeet_selectTab {
  .tabItem {
    cursor: pointer;
    &:hover {
      background-color: var(--mixtmt_mainColor);
      color: var(--mixtmt_whiteColor);
    }
  }
}
</style>
